/**
 * NotificationBadge.tsx - NotificationBadge
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React from 'react';
import { useNotifyr } from '../NotifyrContext';

export const NotificationBadge = ({ userId, onClick }) => {
  const { getUnreadCount } = useNotifyr();
  const unreadCount = getUnreadCount(userId);
  
  if (unreadCount === 0) return null;
  
  return (
    <button className="notifyr-badge" onClick={onClick}>
      🔔
      <span className="notifyr-badge-count">{unreadCount}</span>
    </button>
  );
};

export default NotificationBadge;
